module.exports = __webpack_public_path__ + "img/TRANSPORTE.fe4e7b69.png";